<script setup lang="ts">
import { ref } from 'vue';

const selectedPeriod = ref('');
const reason = ref('');
const confirmed = ref(false);
const reloadingPage = ref(false);
const { openToaster } = useLayoutStore();
const { isUserV2Enabled } = useFeatureFlagsJson();

const handleSubmit = () => {
  openToaster({
    message: 'Autoexclusão Concluída!',
    type: 'success',
  });
  navigateTo(localeLink('/'));
};
</script>

<template>
  <UserV2ScreenSelfExclusion v-if="isUserV2Enabled" />
  <div
    v-else
    class="self-exclusion-page p-4 pt-0"
  >
    <SmarticoBaseHeader
      class="mb-4 select-none"
      :is-hidden-filters="true"
      :reloading-page="reloadingPage"
    >
      Autoexclusão da Conta
    </SmarticoBaseHeader>

    <p class="mb-4 select-none">
      Entendemos que, por vezes, é necessário um tempo para reavaliar seus
      hábitos de jogo. A autoexclusão é uma ferramenta importante para ajudá-lo
      a manter o controle. Ao se autoexcluir, você não poderá acessar sua conta
      por um período determinado.
    </p>

    <p class="mb-6 select-none">
      Por favor, leia as informações abaixo com atenção antes de prosseguir.
    </p>

    <div class="form-container p-6 rounded-lg shadow-md select-none">
      <p class="text-xl font-semibold mb-4">Formulário de Autoexclusão</p>
      <form @submit.prevent="handleSubmit">
        <div class="mb-4">
          <label
            class="block text-sm font-medium label-text mb-2"
            for="period"
          >
            Período de Autoexclusão:
          </label>
          <select
            id="period"
            v-model="selectedPeriod"
            class="block w-full p-2 input-field rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Selecione um período</option>
            <option value="1_month">1 Mês</option>
            <option value="3_months">3 Meses</option>
            <option value="6_months">6 Meses</option>
            <option value="1_year">1 Ano</option>
            <option value="permanent">Permanente</option>
          </select>
        </div>

        <div class="mb-6">
          <label
            class="block text-sm font-medium label-text mb-2"
            for="reason"
          >
            Motivo (Opcional):
          </label>
          <textarea
            id="reason"
            v-model="reason"
            class="block w-full p-2 input-field rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            placeholder="Descreva o motivo da sua autoexclusão..."
            rows="4"
            style="resize: none"
          ></textarea>
        </div>

        <div class="flex items-center mb-6">
          <input
            id="confirm"
            v-model="confirmed"
            class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            type="checkbox"
          />
          <label
            class="ml-2 block text-sm checkbox-label"
            for="confirm"
          >
            Eu entendo que esta ação é irreversível pelo período selecionado.
          </label>
        </div>

        <button
          class="w-full submit-button py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 cursor-not-allowed"
          :disabled="!confirmed || !selectedPeriod"
          type="submit"
        >
          Confirmar Autoexclusão
        </button>
      </form>
    </div>
  </div>
</template>

<style scoped>
.self-exclusion-page {
  color: #f8f8f8; /* Light gray for main text */
}

.form-container {
  background-color: #2d3748; /* Dark blue-gray for form background */
}

.label-text {
  color: #e2e8f0; /* Light blue-gray for labels */
}

.input-field {
  background-color: #4a5568; /* Darker blue-gray for input fields */
  color: #f8f8f8; /* Light gray for input text */
  border-color: #6b7280; /* Gray border */
}

.input-field:focus {
  border-color: #4299e1; /* Blue for focus border */
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5); /* Blue glow on focus */
}

.checkbox-label {
  color: #e2e8f0; /* Light blue-gray for checkbox label */
}

.submit-button {
  background-color: #ef4444; /* Brighter red for button */
  color: #ffffff; /* White text for button */
}

.submit-button:hover {
  background-color: #dc2626; /* Darker red on hover */
}

.submit-button:disabled {
  background-color: #ef4444; /* Keep original red for disabled */
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
